import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import StepProgress from "./steprogress";
import { verifyIFSC, UpdateBankInfo } from "../../../../Service/partnerAPI";
import { showToast } from "../../../../reusableUI/toaster";
import secureLocalStorage from "react-secure-storage";

const BankDetails = () => {
  const navigate = useNavigate();
  const [bankName, setBankName] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [confirmAccountNumber, setConfirmAccountNumber] = useState("");
  const [ifscError, setIfscError] = useState("");
  const [accountError, setAccountError] = useState("");
  const [toastMsg, setToastMsg] = useState(null);

  const verifyIfsc = async (code) => {
    const res = await verifyIFSC(code);
    if (!res.error && res.data) {
      setBankName(`${res.data.BANK}`);
      setIfscError("");
    } else {
      setBankName("");
      setIfscError("Invalid IFSC Code");
    }
  };

  const handleSubmit = async () => {
    if (
      !accountNumber.trim() ||
      !ifscCode.trim() ||
      !confirmAccountNumber.trim()
    ) {
      setToastMsg({
        msg: "Please fill all required fields.",
        action: "Error",
      });
      return;
    }

    if (accountNumber.trim() !== confirmAccountNumber.trim()) {
      setToastMsg({
        msg: "Account numbers do not match.",
        action: "Error",
      });
      return;
    }

    const data = {
      accountNumber: accountNumber,
      ifscCode: ifscCode,
    };

    console.log(data);

    try {
      const res = await UpdateBankInfo(data);
      console.log(res);

      if (res.error === false) {
        secureLocalStorage.setItem("bankInfo", true);
        setToastMsg({
          msg: "Updated bank details successfully.",
          action: "Success",
        });
        setTimeout(() => {
          navigate("/partner/careteam");
        }, 500);
      } else {
        setToastMsg({
          msg: "Failed to update bank details.",
          action: "Error",
        });
      }
    } catch (error) {
      console.error("Error updating bank details:", error);
      setToastMsg({
        msg: "Something went wrong. Please try again later.",
        action: "Error",
      });
    }
  };

  return (
    <div className="min-h-screen bg-[#4951EC] flex flex-col items-center justify-center">
      <StepProgress currentStep={3} />
      <div className="bg-white w-full max-w-md p-6 mt-4 rounded-2xl shadow-lg">
        <h2 className="text-[18px] font-semibold text-gray-800 mb-6 text-center font-poppins">
          Bank Details
        </h2>
        <form className="flex flex-col gap-4">
          <div className="flex flex-col">
            <label className="text-[12px] font-poppins text-gray-700 mb-1">
              Bank Name
            </label>
            <input
              type="text"
              placeholder=""
              value={bankName}
              onChange={(e) => setBankName(e.target.value)}
              className="border border-[#D2D2D2] rounded-sm p-1 font-poppins text-[12px] focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>

          <div className="flex flex-col">
            <label className="text-[12px] font-poppins text-gray-700 mb-1">
              IFSC Code
            </label>
            <input
              type="text"
              placeholder="Enter IFSC code"
              value={ifscCode}
              onChange={(e) => {
                const val = e.target.value.toUpperCase();
                setIfscCode(val);
                if (val.length === 11) {
                  verifyIfsc(val);
                } else {
                  setIfscError("");
                }
              }}
              className="border border-[#D2D2D2] rounded-sm p-1 font-poppins text-[12px] focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
            {ifscError && (
              <span className="text-red-500 text-[11px] mt-1 font-poppins">
                {ifscError}
              </span>
            )}
          </div>

          <div className="flex flex-col">
            <label className="text-[12px] font-poppins text-gray-700 mb-1">
              Account Number
            </label>
            <input
              type="password"
              placeholder="Enter account number"
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
              className="border border-[#D2D2D2] rounded-sm p-1 font-poppins text-[12px] focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>

          <div className="flex flex-col">
            <label className="text-[12px] font-poppins text-gray-700 mb-1">
              Confirm Account Number
            </label>
            <input
              type="text"
              placeholder=""
              value={confirmAccountNumber}
              onChange={(e) => {
                const value = e.target.value;
                setConfirmAccountNumber(value);
                if (accountNumber && value !== accountNumber) {
                  setAccountError("Account numbers do not match");
                } else {
                  setAccountError("");
                }
              }}
              className="border border-[#D2D2D2] rounded-sm p-1 font-poppins text-[12px] focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
            {accountError && (
              <span className="text-red-500 text-[11px] mt-1 font-poppins">
                {accountError}
              </span>
            )}
          </div>

          <button
            type="button"
            onClick={handleSubmit}
            className="mx-24 mt-4 bg-custom-gradient text-[13px] text-white font-poppins py-2 rounded-md transition-all duration-300 hover:brightness-110"
          >
            Save Details
          </button>
        </form>
      </div>
      {/* {toastMsg && <Toaster action={toastMsg.action} msg={toastMsg.msg} />} */}
    </div>
  );
};

export default BankDetails;
